import _classCallCheck from "/home/wspadmin/Dev-Agent4/_work/2/s/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/wspadmin/Dev-Agent4/_work/2/s/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/wspadmin/Dev-Agent4/_work/2/s/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/wspadmin/Dev-Agent4/_work/2/s/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/wspadmin/Dev-Agent4/_work/2/s/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { Component } from 'react';
import PropTypes from 'prop-types';
import shallowEqual from 'shallowequal';
import keyboardOnlyOutlines from '@moxy/keyboard-only-outlines';
var KeyboardOnlyOutlines = /*#__PURE__*/function (_Component) {
  function KeyboardOnlyOutlines() {
    var _this;
    _classCallCheck(this, KeyboardOnlyOutlines);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, KeyboardOnlyOutlines, [].concat(args));
    _defineProperty(_this, "keyboardOutlinesOptions", void 0);
    return _this;
  }
  _inherits(KeyboardOnlyOutlines, _Component);
  return _createClass(KeyboardOnlyOutlines, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.applyKeyboardOutlines();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.applyKeyboardOutlines();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.disposeKeyboardOutlines();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }, {
    key: "applyKeyboardOutlines",
    value: function applyKeyboardOutlines() {
      var options = {};
      if (this.props.stylesheetTarget != null) {
        options.stylesheetTarget = this.props.stylesheetTarget;
      }
      if (this.props.styles != null) {
        options.styles = this.props.styles;
      } // Skip if nothing changed

      if (shallowEqual(options, this.keyboardOutlinesOptions)) {
        return;
      }
      this.keyboardOutlinesOptions = options;
      this.disposeKeyboardOutlines();
      this.dispose = keyboardOnlyOutlines(options);
    }
  }, {
    key: "disposeKeyboardOutlines",
    value: function disposeKeyboardOutlines() {
      if (this.dispose) {
        this.dispose();
        this.dispose = undefined;
      }
    }
  }]);
}(Component);
export { KeyboardOnlyOutlines as default };
_defineProperty(KeyboardOnlyOutlines, "propTypes", {
  children: PropTypes.node,
  stylesheetTarget: PropTypes.object,
  styles: PropTypes.string
});
_defineProperty(KeyboardOnlyOutlines, "defaultProps", {
  children: null
});